import { htmlIdGenerator } from "@elastic/eui";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  datas: [],
};

export const alertSlice = createSlice({
  name: "alerts",
  initialState,
  reducers: {
    popSuccess: (state, action) => {
      state.datas.push({
        id: htmlIdGenerator()(),
        color: "success",
        iconType: "check",
        ...action.payload,
      });
    },
    popWarning: (state, action) => {
      state.datas.push({
        id: htmlIdGenerator()(),
        color: "warning",
        iconType: "help",
        ...action.payload,
      });
    },
    // Use the PayloadAction type to declare the contents of `action.payload`
    popError: (state, action) => {
      state.datas.push({
        id: htmlIdGenerator()(),
        color: "danger",
        iconType: "alert",
        ...action.payload,
      });
    },
    alertClear: (state, action) => {
      state.datas = state.datas.filter(
        (toast) => toast.id !== action.payload.id
      );
    },

    alertClearAll: (state) => {
      state.datas = [];
    },
  },
});

export const { popSuccess, popWarning, popError, alertClear, alertClearAll } =
  alertSlice.actions;

export const selectToasts = (state) => state.alerts.datas;

export default alertSlice.reducer;
